// 财务合同（销售合同下的业务单据页面配置）
// 【P15】财务合同由系统自动生成（支付审批通过后创建 / 余额转款自动创建），
//       禁止手动新增/编辑/删除：readonly 隐藏全部操作按钮，后端三接口同步 400 拦截，仅可查看。
// 【P16】详情弹窗聚合：客户名称/签约时间/起止时间/金额/类型/状态(stage) + 关联会议室/回款单/发票/退款记录。
import { getContractFinanceContractListData, getFinanceContractDetailData } from "../../api/api.js";

export default {
  key: "financeContract",
  title: "财务合同",
  short: "财务合同",
  icon: "records",
  readonly: true,
  emptyHint: "财务合同由系统自动生成，仅可查看",
  listFn: getContractFinanceContractListData,
  detailFn: getFinanceContractDetailData,
  // 详情弹窗底部关联区块（顺序即渲染顺序）
  related: [
    { key: "rooms", label: "关联会议室" },
    { key: "payments", label: "回款单" },
    { key: "invoices", label: "发票" },
    { key: "refunds", label: "退款记录" }
  ],
  // 卡片标题：财务合同号 · 金额
  titleFields: ["finance_no", "amount", "sign_date"],
  fields: [
    { prop: "finance_no", label: "财务合同号", type: "text", group: "合同信息" },
    { prop: "name", label: "合同名称", type: "text", group: "合同信息" },
    { prop: "customer_name", label: "客户名称", type: "text", group: "合同信息" },
    { prop: "signing_date", label: "签约时间", type: "date", group: "合同信息" },
    { prop: "start_date", label: "开始时间", type: "date", group: "合同信息" },
    { prop: "end_date", label: "结束时间", type: "date", group: "合同信息" },
    { prop: "amount", label: "金额", type: "number", group: "合同信息" },
    { prop: "payment_amount", label: "已回款", type: "number", group: "合同信息" },
    { prop: "category_name", label: "类型", type: "text", group: "合同信息" },
    { prop: "stage_name", label: "状态", type: "text", group: "合同信息" },
    { prop: "status_name", label: "单据状态", type: "text", group: "合同信息" },
    { prop: "remark", label: "备注", type: "textarea", group: "合同信息" }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/contract/FinanceContracts.js